import { Segments, SharedColors } from "apparatus/library/common";
import { DEFAULT_SWATCHES } from "components/colorpicker";
import { Path } from "paper";
export class PaperClip {
    render(appearance) {
        const graphic = new Path(Segments([[-20, 49]], [[-20, -68], , [0, -22]], [[19, -68], [0, -22]], [[19, 105], , [0, 30]], [[-40, 105], [0, 30]], [[-40, -105], , [0, -45]], [[38, -105], [0, -45]], [[38, 48]])).withStroke(appearance.scale * 2, appearance.color);
        graphic.strokeCap = "round";
        graphic.scale(appearance.scale * 0.125);
        return {
            graphic,
            hitShape: graphic.bounds.expand(5).toShape()
        };
    }
}
PaperClip.properties = {
    label: "Paper Clip",
    flippable: true,
    defaultAppearance: {
        scale: 1.0,
        color: SharedColors.stroke,
    },
    appearanceSpecs: [
        {
            spec: "slider", key: "scale", label: "Zoom",
            min: 1, max: 5, step: 0.01, unit: "%",
        },
        {
            spec: "color", key: "color", label: "Colour", tier: "boost",
            demoSwatches: { "Default": SharedColors.stroke, "Metal": "#999999" },
            swatches: Object.assign({ "Default": SharedColors.stroke, "Metal": "#999999" }, DEFAULT_SWATCHES)
        }
    ],
};
